<template>
  <Card
    variant="prompt"
    :title="$t('editMultipleUnitsConcurrently')"
    :subtitle="$t('unitsSelectFieldsToEdit')"
    class="residentials-update__select-fields"
  >
    <template #default>
      <VirtualCategory
        v-if="items.length"
        wrapper="div"
        :items="items"
        mode="select-only"
        v-model="selectedComp"
        :disable-sort="true"
        view="default"
      />

      <Alert v-if="excludedFields.length" theme="warning" class="residentials-update__select-fields-excluded-fields">
        <p>
          <strong>{{ $t('unitsTollowingFieldsCannotBeEdited') }}: </strong>
        </p>

        <div class="residentials-update__select-fields-excluded-fields-items row">
          <div v-for="field in excludedFields" icon="fa-pro-light:ban" class="row">
            {{ field.label }}
            <HelperPopover class="ml-1 pull-left">
              <template #body> {{ field.tooltip }} </template>
            </HelperPopover>
          </div>
        </div>
      </Alert>
    </template>

    <template #actions>
      <slot name="navigation"></slot>
    </template>
  </Card>
</template>

<script>
import { CheckboxComponent } from 'vue-elder-checkbox'
import { InputComponent } from 'vue-elder-input'
import Card from '@/components/Card-v2'
import VirtualCategory from '@/components/VirtualCategory'
import Badge from '@/components/Badge'
import HelperPopover from '@/components/HelperPopover/Component'
import { AlertComponent as Alert } from 'vue-elder-alert'

const meta = {
  order: 1,
  id: 'select-fields',
}

const include = [
  'description',
  'media-cover',
  'media-files',
  'media-gallery',
  'facilities',
  'properties',
  'status',
  {
    key: 'value',
    parent: 'sale',
    forceDisplay: true,
  },

  {
    key: 'fixed',
    parent: 'sale',
  },
  {
    key: 'fee',
    parent: 'sale',
  },
  {
    key: 'jointDebtInterestRate',
    parent: 'sale',
  },
  {
    key: 'jointDebt',
    parent: 'sale',
  },
  {
    key: 'deposit',
    parent: 'sale',
  },
]

export { meta }
export default {
  props: {
    labels: Object,
    validator: Object,
    selected: Object,
    residentials: Array,
    schemas: Array,
    disabledFields: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      excludedFields: [],
    }
  },

  computed: {
    selectedComp: {
      get() {
        return this.selected.value
      },
      set(val) {
        const key = (this.fields.find(i => i.label === val) || {}).key

        const match = include.find(i => {
          return (i.key || i).includes(key)
        })
        this.selected.value = val

        this.selected.key = key
        if (match) {
          this.selected.parent = match.parent
        }
      },
    },
    hasMultipleSaleTypes() {
      return Array.from(new Set(this.residentials.map(r => r.sale.type))).length > 1
    },
    hasRentSaleType() {
      return this.residentials.find(r => r.sale.type === 'rent')
    },

    items() {
      return this.fields.map(i => i.label)
    },

    fields() {
      return this.schemas
        .map(i => this.buildCategories(i))
        .flat(Infinity)
        .filter(Boolean)
    },
  },
  methods: {
    buildCategories(value) {
      let items = value.component
      if (!(items instanceof Array)) items = [{ ...value }]
      return items.map(c => {
        const item = include.find(i => {
          return (i.key || i).includes(c.key)
        })

        if (!item) return

        let { disabled, tooltip } = this.isDisabled(c.key)

        if (disabled) {
          this.excludedFields.push({ label: c.label, tooltip })
          return
        }
        if (item.parent === 'sale' && this.hasRentSaleType && !item.forceDisplay) return
        if (item.parent) {
          c.label = `${this.$t(item.parent)}/${c.label}`
        }

        return c
      })
    },

    isDisabled(key) {
      key = key.replace('-', '.')
      const match = include.find(i => {
        return (i.key || i).includes(key)
      })
      if (match && match.parent) {
        key = match.parent
      }

      if (['status', 'sale'].includes(key) && this.hasMultipleSaleTypes)
        return { disabled: true, tooltip: this.$t('cannotEditMultipleResidentialFieldsSameSaleType') }

      const Map = {
        sale: 'price',
        cover: 'media.cover',
        floorplan: 'media.floorplan',
        gallery: 'media.gallery',
      }

      const tooltip = this.disabledFields[Map[key] || key]

      return tooltip ? { disabled: true, tooltip } : {}
    },
  },
  components: {
    CheckboxComponent,
    InputComponent,
    Card,
    VirtualCategory,
    Badge,
    HelperPopover,
    Alert,
  },
}
</script>

<style lang="scss">
.residentials-update__select-fields {
  &-excluded-fields {
    margin-top: 2rem;
    &-items {
      flex-wrap: wrap;
      gap: 0.5rem;
      & > * {
        border-radius: var(--border-radius);
        border: 1px solid var(--border-color);
        padding: 0.3rem;
      }
    }
  }
  .elder-input__element {
    & > * + * {
      margin-top: 0.5rem;
    }
  }
}
</style>
